import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router'; // Will be router/index.ts
import './assets/styles/main.scss';

// Import global styles if you have them, e.g., './assets/styles/global.css'

/* import Font Awesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import all solid icons (or specific icons to reduce bundle size) */
import { fas } from '@fortawesome/free-solid-svg-icons';

/* add icons to the library */
library.add(fas);

const app = createApp(App);

app.use(createPinia()); // Use Pinia for state management
app.use(router); // Use Vue Router for navigation
app.component('font-awesome-icon', FontAwesomeIcon); // Register FontAwesomeIcon component globally

app.mount('#app');